import React, { useEffect } from 'react'
import { useRecoilValue } from 'recoil'
import styled from '@emotion/styled'
import { BulkFile } from '../../cms/models/BulkFile'
import { BulkFileStore } from './service'
import ItemRow from './ItemRow'
import {
	cmsObjectsLoader,
	productDataSelector
} from '../../state/state'
import { cmsModelsSelector } from '../../state/models'
import { Types } from '../../cms/types'
import { getFormConfig } from '../../utils/decorators'
import {
	bulkTableState,
	bulkUploadFilesSelector,
	bulkTableFilterAtom
} from './state'

const EmptySate = styled.td`
	padding: 64px 0;
	vertical-align: middle;
	height: 200px;

	h4 {
		font-family: var(--font-semi-bold);
		font-size: 20px;
		margin-bottom: 24px;
	}
`

const BulkFiles = () => {
	// preload required data for bulk rows
	const documentModel = useRecoilValue(cmsModelsSelector(Types.DOCUMENT))
	const audioModel = useRecoilValue(cmsModelsSelector(Types.AUDIO))

	useRecoilValue(cmsObjectsLoader([Types.CONTENT_TYPE]))
	useRecoilValue(productDataSelector)
	useRecoilValue(bulkTableState)
	const filters = useRecoilValue(bulkTableFilterAtom)
	const list = useRecoilValue(bulkUploadFilesSelector)

	useEffect(() => {
		const modelTypes = [Types.AUDIO, Types.DOCUMENT]
		for (let t of modelTypes) {
			const config = getFormConfig(t)
			BulkFile.models[t] = config.model
		}
	}, [documentModel, audioModel])

	useEffect(() => {
		BulkFileStore.initialize(list)
	}, [list])

	if (BulkFileStore.getAll().length === 0) {
		return (
			<tr>
				<EmptySate colSpan={11}>
					<h4>There are no files here</h4>
					<div>
						Drag and drop files here to upload or select from your computer
					</div>
				</EmptySate>
			</tr>
		)
	}

	return (
		<>
			{BulkFileStore.filteredFiles(filters).map((item, idx) => (
				<ItemRow key={idx} file={item} />
			))}
		</>
	)
}

export default BulkFiles
